import React from 'react';
import { ResponsiveDataList, type Column } from '@shared/ui/adaptive';
import type { FormSubmission } from '../types';

export interface SubmissionsListProps {
  submissions: FormSubmission[];
}

// SubmissionsList presents conversion form submissions via ResponsiveDataList (M-I3).
export function SubmissionsList({ submissions }: SubmissionsListProps): React.JSX.Element {
  const columns: Column<FormSubmission>[] = [
    {
      key: 'idempotencyKey',
      header: 'Idempotency Key',
      render: (s: FormSubmission) => <span className="font-mono text-xs">{s.idempotencyKey.slice(0, 18)}...</span>,
      width: '20%',
    },
    {
      key: 'payload',
      header: 'Submitted Data',
      render: (s: FormSubmission) => (
        <div className="text-xs font-mono text-foreground flex flex-wrap gap-1.5 max-w-sm truncate">
          {Object.entries(s.payload || {}).map(([k, v]) => (
            <span key={k} className="bg-muted/70 px-1.5 py-0.5 rounded text-[11px]">
              <strong className="text-muted-foreground">{k}:</strong> {String(v)}
            </span>
          ))}
        </div>
      ),
      width: '40%',
    },
    {
      key: 'syncStatus',
      header: 'Sync Status',
      render: (s: FormSubmission) => (
        <span
          className={`px-2 py-0.5 rounded-full text-xs font-semibold uppercase tracking-wider ${
            s.syncStatus === 'synced' ? 'bg-accent/15 text-accent' : 'bg-muted text-muted-foreground'
          }`}
        >
          {s.syncStatus}
        </span>
      ),
      width: '15%',
    },
    {
      key: 'date',
      header: 'Submitted At',
      render: (s: FormSubmission) => <span className="text-muted-foreground text-xs">{s.createdAt}</span>,
      width: '25%',
    },
  ];

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-semibold text-foreground">Visitor Form Submissions</h2>
        <span className="text-xs text-muted-foreground">{submissions.length} submissions recorded</span>
      </div>
      <ResponsiveDataList<FormSubmission>
        data={submissions}
        keyExtractor={(s: FormSubmission) => s.id}
        columns={columns}
        emptyMessage="No form submissions recorded yet."
      />
    </div>
  );
}
